import { DataLocationPointer, DataSchema } from '@integration-app/sdk'
import deepEqual from 'fast-deep-equal'

import Schema from './Schema'
import { SchemaBuilderContextProvider } from './SchemaContext'
import { SchemaBuilderReferenceSchema } from './types'

export interface SchemaBuilderProps {
  schema: DataSchema | undefined
  referenceCollections?: DataLocationPointer[]
  referenceSchemas?: SchemaBuilderReferenceSchema[]
  variablesSchema?: DataSchema
  isObject?: boolean
  name?: string
  onChange?: (schema: DataSchema) => void
  readOnly?: boolean
  className?: string
}

export default function SchemaBuilder({
  schema,
  variablesSchema,
  referenceCollections,
  referenceSchemas,
  isObject = true,
  readOnly = false,
  name = '',
  onChange,
  className,
}: SchemaBuilderProps) {
  if (!schema) {
    schema = isObject
      ? {
          type: 'object',
        }
      : {}
  }

  if (isObject && schema?.type !== 'object') {
    schema = { type: 'object' }
  }

  function handleChange(newSchema: DataSchema) {
    if (!readOnly && onChange && !deepEqual(schema, newSchema)) {
      onChange(newSchema)
    }
  }

  function handleAddProperty() {
    onChange?.({
      ...schema,
      properties: {
        /* FIXME: strictNullCheck temporary fix */
        // @ts-expect-error TS(2532): Object is possibly 'undefined'.
        ...(schema.properties ?? {}),
        ['']: {
          type: 'string',
        },
      },
    })
  }

  return (
    <SchemaBuilderContextProvider
      variablesSchema={variablesSchema}
      referenceCollections={referenceCollections}
      referenceSchemas={referenceSchemas}
      readOnly={readOnly}
      isObject={isObject}
    >
      <div className={className}>
        <Schema
          name={name}
          schema={schema}
          level={0}
          onChange={handleChange}
          onAdd={handleAddProperty}
        />
      </div>
    </SchemaBuilderContextProvider>
  )
}
